import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["placement"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useTooltipViewType, ETooltipViewType, useOpenCloseControlled } from '../../internal';
import { TooltipMobile } from '../TooltipMobile';
import { TooltipDesktop } from '../TooltipDesktop';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент подсказки
 *
 * На телефоне работает как модальное окно
 * На планшете и десктопе работает как всплывающее окно при наведении
 *
 * Так же есть компоненты TooltipDesktop и TooltipMobile,
 * для того чтобы использовать одну конкретную версию,
 * если микросервис не подразумевает адаптива
 *
 * @export
 * @param {ITooltipProps} props
 * @returns
 */
export function Tooltip(_ref) {
  var _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'top' : _ref$placement,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useOpenCloseControll = useOpenCloseControlled(props),
    handleOpen = _useOpenCloseControll.handleOpen,
    handleClose = _useOpenCloseControll.handleClose,
    open = _useOpenCloseControll.open;
  var viewType = useTooltipViewType({
    open: open,
    onClose: handleClose
  });
  if (viewType === ETooltipViewType.Modal) {
    return /*#__PURE__*/_jsx(TooltipMobile, _objectSpread(_objectSpread({}, props), {}, {
      open: open,
      onOpen: handleOpen,
      onClose: handleClose
    }));
  }
  return /*#__PURE__*/_jsx(TooltipDesktop, _objectSpread(_objectSpread({
    placement: placement
  }, props), {}, {
    open: open,
    onOpen: handleOpen,
    onClose: handleClose
  }));
}